import { render } from "./DashboardPage.vue?vue&type=template&id=a86eeb5c&scoped=true&ts=true"
import script from "./DashboardPage.vue?vue&type=script&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=a86eeb5c&scoped=true&lang=css"
import "./DashboardPage.vue?vue&type=style&index=1&id=a86eeb5c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86eeb5c"]])

export default __exports__